/* istanbul ignore file */
export enum BorganActionTypeEnum {
	INCIDENCE = 'incidence',
	REQUEST = 'request'
}
